export default __webpack_public_path__ + "static/media/Arrow_right-2.c5e40d1b.svg";